module.exports = __webpack_public_path__ + "static/media/British_Eventing.92f42724.jpg";